<template>
  <div v-if="Lib.checkPower('beauty-2-ckyy',2)" class="receptionOverflow">
    <div class="flex">
      <drawer title="预约筛选" :display.sync="display">
        <div class="li">
          <p>选择日期</p>
          <el-button v-for="(v,n) in date" :key="n" size="small" :type="chooseDateVal == n ? 'primary' : ''" @click="chooseDate(n)">{{ v }}</el-button>
          <el-date-picker v-model="value" size="small" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :editable="false" @change="chooseTime"></el-date-picker>
        </div>
        <div class="li">
          <p>快速查找</p>
          <el-input v-model.trim="inputVal" size="small" placeholder="请输入顾客姓名/联系电话" @keyup.enter.native="search">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
          </el-input>
        </div>
        <div class="li">
          <p>选择{{ Lib.collectively() }}</p>
          <el-select v-model="technicianVal" clearable style="width: 100%;" size="small" :placeholder="'请选择'+Lib.collectively()" @change="search">
            <el-option v-for="(v,n) in technicianList" :key="n" :label="v.name" :value="v.id"></el-option>
          </el-select>
        </div>
        <div class="li">
          <p>预约状态</p>
          <el-button v-for="(v,n) in bespeakScreenData" :key="n" size="small" :type="bespeakStatus == v.status ? 'primary' : ''" @click="chooseStatus(v.status)">{{ v.name }}</el-button>
        </div>
        <div class="li">
          <p>来源</p>
          <el-button size="small" :type="sourceStatus == null ? 'primary' : ''" @click="chooseSource(null)">全部</el-button>
          <el-button size="small" :type="sourceStatus == 0 ? 'primary' : ''" @click="chooseSource(0)">粉丝端</el-button>
          <el-button size="small" :type="sourceStatus == 2 ? 'primary' : ''" @click="chooseSource(2)">店员APP</el-button>
          <el-button size="small" :type="sourceStatus == 1 ? 'primary' : ''" @click="chooseSource(1)">电脑端</el-button>
        </div>
        <div class="li">
          <p>备注</p>
          <el-input v-model.trim="remark" size="small" placeholder="请输入备注进行搜索" @keyup.enter.native="search">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
          </el-input>
        </div>
        <div class="li">
          <p>顾客类型</p>
          <el-button size="small" :type="ctypeStatus == null ? 'primary' : ''" @click="chooseCtype(null)">全部</el-button>
          <el-button size="small" :type="ctypeStatus == 1 ? 'primary' : ''" @click="chooseCtype(1)">普通顾客</el-button>
          <el-button size="small" :type="ctypeStatus == 2 ? 'primary' : ''" @click="chooseCtype(2)">会员顾客</el-button>
        </div>
        <div class="dfoot" @click="infoReset">重置</div>
        <!-- <el-button class="ml_20" type="primary" @click="addBespeak">新增预约</el-button> -->
        <!-- <el-button class="ml_20"  type="primary" @click="setScheduling">设置排班</el-button> -->
      </drawer>
      <div v-loading="loading" style="width: 100%;height: 600px;position: absolute;z-index: -1;"></div>
      <div class="commonTable" style="margin-bottom: 48px;">
        <i class="iconfont screen" @click="display = true">&#xe63f;</i>
        <el-table v-loading="loading" :data="tableData" tooltip-effect="light">
          <!-- <el-table-column label="确认情况" width="80" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isRead == 0" style="color: #ff2233;">新订单</span>
                            <span style="color: #999;" v-else>已读</span>
                        </template>
                    </el-table-column>-->
          <el-table-column label="预约日期" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.dateStr ? scope.row.dateStr : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="预约时间段" width="140" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.timeStr ? scope.row.timeStr : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="technicianName" :label="'预约'+Lib.collectively()" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="line-height: 28px;">{{ scope.row.technicianName || '到店安排' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="itemName" label="预约项目" :show-overflow-tooltip="true">
            <template slot-scope="scope">{{ scope.row.itemName || '--' }}</template>
          </el-table-column>
          <el-table-column prop="memberName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="phone" label="联系电话" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.phone ? Lib.starPhone(scope.row.phone) : '--' }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="备注" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>{{scope.row.remark ? scope.row.remark : '--'}}</span>
                        </template>
                    </el-table-column>-->
          <el-table-column label="来源" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.source == 0">粉丝端</span>
              <span v-else-if="scope.row.source == 1">电脑端</span>
              <span v-else-if="scope.row.source == 2">店员APP</span>
              <span v-else-if="scope.row.source == 3">样子APP</span>
              <span v-else-if="scope.row.source == 4">样子小程序</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" min-width="140px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span :style="Lib.getBespeakVal(scope.row.status,2)">{{ Lib.getBespeakVal(scope.row.status,1) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="240">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0 || scope.row.status == 3">
                <yz-btn type="primary" @click="bespeakDetails(scope.row.id)">详情</yz-btn>
                <yz-btn type="primary" @click="bespeakBilling(scope.row.id)">开单</yz-btn>
                <yz-btn type="primary" @click="bespeakEdit(scope.row.id,scope.row.orderSource)">修改</yz-btn>
                <yz-btn type="delete" @click="cancelBespeak(scope.row.id,2)">取消</yz-btn>
              </div>
              <div v-else-if="scope.row.status == 4">
                <yz-btn type="primary" @click="bespeakDetails(scope.row.id)">详情</yz-btn>
                <yz-btn type="primary" @click="cancelBespeak(scope.row.id,1)">确认</yz-btn>
                <yz-btn type="delete" @click="cancelBespeak(scope.row.id,0)">拒绝</yz-btn>
              </div>
              <div v-else-if="scope.row.status == 1">
                <yz-btn type="primary" @click="bespeakDetails(scope.row.id)">详情</yz-btn>
                <yz-btn type="primary" @click="settlementOrder(scope.row.orderId)">结算</yz-btn>
              </div>
              <yz-btn v-else type="primary" @click="bespeakDetails(scope.row.id)">详情</yz-btn>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableData.length > 0" class="allFooter">
        <el-pagination background :current-page.sync="pageNum" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="560px" :append-to-body="true">
      <span v-show="diaStatus === 2">确定要取消这条预约吗？</span>
      <span v-show="diaStatus === 0">确认要拒绝这条预约订单吗？</span>
      <p v-if="cancelStatus == 0">已超过预约可退定金时间，若顾客已支付定金/使用了划扣次数，取消订单后，定金/划扣次数将<samp class="themeFC">不会</samp>退回顾客</p>
      <p v-if="cancelStatus == 1">若顾客已支付定金/使用了划扣次数，{{ diaStatus == 2 ? '取消' : '拒绝' }}订单后，定金/划扣次数将退回顾客</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmCancelBespeak">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="yyDetails" title="预约详情" :visible.sync="detailsVisible" width="560px" :append-to-body="true">
      <div class="yyTop">
        <i class="iconfont" :style="(detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4 || detailsInfo.status == 2) ? 'color: #67C23A;' : 'color: #C4C0C0'">{{ (detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? '&#xe65e;' : ( detailsInfo.status == 2) ? '&#xe767;' : '&#xe65f;' }}</i>
        <span>{{ (detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? '已预约' : ( detailsInfo.status == 2) ? '已完成' : '已取消' }}</span>
        <samp :style="(detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? 'color: #FA5555;' : 'color: #999;'">{{ detailsInfo.status == 0 ? '待服务' : detailsInfo.status == 1 ? '服务中' : detailsInfo.status == 3 ? '预约超时' : detailsInfo.status == 4 ? '待确认' : detailsInfo.status == -1 ? '商家取消' : detailsInfo.status == -2 ? '预约过期' : detailsInfo.status == -3 ? '用户取消' : detailsInfo.status == -4 ? '商家拒绝' : '' }}</samp>
      </div>
      <div class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">预约信息</span>
      </div>
      <div class="yyInfo">
        <p>
          <span>姓名：</span>
          <samp>{{ detailsInfo.memberName }}</samp>
        </p>
        <p>
          <span>联系电话：</span>
          <samp>{{ detailsInfo.phone }}</samp>
        </p>
        <p>
          <span>预约时间：</span>
          <samp>{{ detailsInfo.bookDateTime }}</samp>
        </p>
        <p>
          <span>预约项目：</span>
          <samp>{{ detailsInfo.bookItemName }}</samp>
        </p>
        <p>
          <span>预约{{ Lib.collectively() }}：</span>
          <samp>{{ detailsInfo.bookTechnicianName }}</samp>
        </p>
        <p>
          <span>服务时长：</span>
          <samp>{{ detailsInfo.serviceTime }}分钟</samp>
        </p>
        <p>
          <span>备注：</span>
          <samp>{{ detailsInfo.remark || '--' }}</samp>
        </p>
      </div>
      <div class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">其他信息：</span>
      </div>
      <div class="yyInfo">
        <p>
          <span>下单时间：</span>
          <samp>{{ detailsInfo.orderTime }}</samp>
        </p>
        <p>
          <span>来源：</span>
          <samp>{{ detailsInfo.orderSource }}</samp>
        </p>
        <p>
          <span>操作人：</span>
          <samp>{{ detailsInfo.dutyName }}</samp>
        </p>
        <h5 v-if="detailsInfo.orderCode">
          <span>订单号码：</span>
          <samp>{{ detailsInfo.orderCode }}</samp>
          <i class="el-icon-arrow-right" @click="lookOrder(detailsInfo.orderId,detailsInfo.orderType,detailsInfo.orderStatus,detailsInfo)"></i>
          <label @click="lookOrder(detailsInfo.orderId,detailsInfo.orderType,detailsInfo.orderStatus,detailsInfo)">查看订单</label>
        </h5>
      </div>
      <div v-if="(detailsInfo.status == -1 || detailsInfo.status == -2 || detailsInfo.status == -3 || detailsInfo.status == -4)" class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">取消信息：</span>
      </div>
      <div v-if="(detailsInfo.status == -1 || detailsInfo.status == -2 || detailsInfo.status == -3 || detailsInfo.status == -4)" class="yyInfo">
        <p>
          <span>取消时间：</span>
          <samp>{{ detailsInfo.cancelTime }}</samp>
        </p>
        <p>
          <span>取消原因：</span>
          <samp>{{ detailsInfo.cancelCase }}</samp>
        </p>
      </div>
      <div class="yyFoot">
        <div v-if="detailsInfo.status == 0 || detailsInfo.status == 3">
          <el-button type="primary" @click="bespeakBilling(detailsInfo.orderId)">开单</el-button>
          <el-button type="primary" @click="bespeakEdit(detailsInfo.orderId,detailsInfo.orderSource)">修改</el-button>
          <el-button type="primary" @click="cancelBespeak(detailsInfo.orderId,2)">取消</el-button>
        </div>
        <div v-else-if="detailsInfo.status == 4">
          <el-button type="primary" @click="cancelBespeak(detailsInfo.orderId,1)">确认</el-button>
          <el-button type="primary" @click="cancelBespeak(detailsInfo.orderId,0)">拒绝</el-button>
        </div>
        <div v-else-if="detailsInfo.status == 1">
          <el-button type="primary" @click="settlementOrder(detailsInfo.orderId)">结算</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="'订单号-'+orderCode+'--'+orderTypeName" :visible.sync="orderDeatilsDialog" :append-to-body="true" width="1000px">
      <yzOrderDeatils :order-deatils-data="orderDeatilsData" :order-deatils-dialog="orderDeatilsDialog" :loading="loading2" @newGetListData="newGetListData" @tansferDialog="getDialogData" />
    </el-dialog>

    <gt-footer></gt-footer>
  </div>
  <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
</template>

<script>
import dayjs from 'dayjs';
import DfSocket from 'df-plugins/src/socket/index.js';
import {
  getBookFailures,
  getBookOrderList,
  bookRead,
  getBookReadStatus,
  getSureOrFalse,
  getBookCancelMsg,
  getToken,
  getBookOrderDetail,
  // getOrderDetail4AllDto,
  getTechnicianList
} from './api';
import yzOrderDeatils from '../../stage/template/orderDetails/index';
import drawer from '../drawer';

export default {
  components: {
    drawer,
    yzOrderDeatils
  },
  data() {
    return {
      display: false,
      bespeakScreenData: [
        {
          status: '',
          name: '全部'
        }, {
          status: '5',
          name: '已预约'
        }, {
          status: '2',
          name: '已完成'
        }, {
          status: '-5',
          name: '已取消'
        }, {
          status: '4',
          name: '已预约-待确认'
        }, {
          status: '0',
          name: '已预约-待服务'
        }, {
          status: '1',
          name: '已预约-服务中'
        }, {
          status: '3',
          name: '已预约-预约超时'
        }, {
          status: '-1',
          name: '已取消-商家取消'
        }, {
          status: '-4',
          name: '已取消-商家拒绝'
        }, {
          status: '-3',
          name: '已取消-用户取消'
        }, {
          status: '-2',
          name: '已取消-预约过期'
        }
      ], // 预约状态筛选值

      value: '', // 时间段
      inputVal: '', // 搜索值
      bespeakStatus: '', // 预约状态
      tableData: [], // 预约列表数据
      pageNum: 1,
      rowCount: 1,
      pageSize: 15,
      dialogVisible: false, // 取消预约--弹出框
      chooseId: '', // 选择的列表ID
      diaStatus: 3, // 弹出窗口文案提示状态
      cancelStatus: 1, // 取消预约退不退定金

      // 5.7
      loading: true,

      // 6.6
      date: ['今日', '昨日', '明日', '本月'],
      chooseDateVal: null,
      remark: '', // 备注信息
      sourceStatus: null, // 来源状态
      detailsVisible: false,
      detailsInfo: {},
      orderDeatilsDialog: false,
      orderCode: '',
      orderTypeName: '', // 订单类型名称
      orderDeatilsData: {
        itemList: [],
        payTypeList: []
      },
      loading2: true,
      technicianVal: '',
      technicianList: [],
      // 6.7
      ctypeStatus: null, // 顾客类型
    };
  },
  mounted() {
    const vm = this;
    if (sessionStorage.getItem('token')) {
      const socketOptions = {
        scene: `/push?scene=1&tags=beauty-${sessionStorage.getItem('mainId')}&token=${sessionStorage.getItem('token')}`,
        messageTags: [`beauty-${sessionStorage.getItem('mainId')}`],
        message(sdata) {
          vm.callback(sdata.payload);
        }, // socket推送的数据
        connect() {},
        disconnect() {}, // 连接断开
        reconnectFailed() {}, // 重连失败
        error() {}, // 连接失败错误信息
      };
      new DfSocket(socketOptions).start(); // 开始连接
    } else {
      getToken().then((res) => {
        const socketOptions = {
          scene: `/push?scene=1&tags=beauty-${sessionStorage.getItem('mainId')}&token=${res.data}`,
          messageTags: [`beauty-${sessionStorage.getItem('mainId')}`],
          message(sdata) {
            vm.callback(sdata.payload);
          }, // socket推送的数据
          connect() {},
          disconnect() {}, // 连接断开
          reconnectFailed() {}, // 重连失败
          error() {}, // 连接失败错误信息
        };
        new DfSocket(socketOptions).start(); // 开始连接
      });
    }
  },
  activated() {
    const date = new Date();
    const today = this.Lib.D(date.getTime(), 'yyyy-MM-dd');
    const todaySeven = this.Lib.D(date.getTime() + 3600 * 1000 * 24 * 2, 'yyyy-MM-dd');
    this.value = [today, todaySeven];
    this.bespeakStatus = '';
    this.sourceStatus = null;
    this.ctypeStatus = null;
    this.initialize();
    this.getBookReadStatus();
    this.getTechnicianListData();
  },
  methods: {
    // 获取项目员工列表
    getTechnicianListData() {
      getTechnicianList({ mainId: sessionStorage.getItem('mainId') }).then((res) => {
        if (res.code == 0) {
          this.technicianList = res.data ? res.data : [];
        } else {
          // console.log(res)
        }
      });
    },
    // 调用公共组件--赋值
    getDialogData(list) {
      this.orderDeatilsDialog = list;
    },
    // 子父组件赋值
    newGetListData() {
      this.getListData();
      this.$emit('getDelStatus', true);
    },
    // 查看订单
    // lookOrder(orderId, orderType, status) {
    //   const data = {
    //     id: orderId,
    //     orderType
    //   };
    //   this.loading2 = true;
    //   this.orderDeatilsDialog = true;
    //   this.orderTypeName = this.Lib.getOrderTypeName(orderType);
    //   getOrderDetail4AllDto(data).then((res) => {
    //     if (res.code === 0) {
    //       res.data.itemList = res.data.itemList ? res.data.itemList : [];
    //       res.data.giftItemList = res.data.giftItemList ? res.data.giftItemList : [];
    //       res.data.giftItemList.forEach((a) => {
    //         a.isGift = a.activityId ? a.activityType == 3 ? 2 : a.activityType == 4 ? 3 : 1 : 1;
    //       });
    //       res.data.itemList = res.data.itemList.concat(res.data.giftItemList);
    //       res.data.itemList.forEach((a) => {
    //         // a.refundType = a.refundType === null
    //         a.refundNum = '0';
    //         a.refundCount = '0';
    //         a.refundMoney = a.resultPrice;
    //       });
    //       res.data.newStatus = status;
    //       res.data.refundStatus = res.data.refundStatus ? res.data.refundStatus : 0;
    //       this.orderDeatilsData = res.data;
    //       this.orderCode = res.data.dtoList ? res.data.dtoList.orderCode : res.data.orderCode;
    //       this.loading2 = false;
    //     }
    //   });
    // },
    // 查看订单
    lookOrder(orderId, orderType, status, v) {
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    },
    // socket回调监听
    callback(data) {
      if (data.code == 0) {
        this.initialize(1);
      }
    },
    chooseDate(val) {
      this.chooseDateVal = val;
      this.pageNum = 1;
      this.getListData();
    },
    // 选择时间段
    chooseTime() {
      this.chooseDateVal = null;
      this.pageNum = 1;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.getListData();
    },
    // 选择预约状态
    chooseStatus(val) {
      this.bespeakStatus = val;
      this.pageNum = 1;
      this.getListData();
    },
    chooseSource(val) {
      this.sourceStatus = val;
      this.pageNum = 1;
      this.getListData();
    },
    chooseCtype(val) {
      this.ctypeStatus = val;
      this.pageNum = 1;
      this.getListData();
    },
    // 重置
    infoReset() {
      const date = new Date();
      const today = this.Lib.D(date.getTime(), 'yyyy-MM-dd');
      const todaySeven = this.Lib.D(date.getTime() + 3600 * 1000 * 24 * 2, 'yyyy-MM-dd');
      this.value = [today, todaySeven];
      this.inputVal = '';
      this.technicianVal = '';
      this.remark = '';
      this.bespeakStatus = '';
      this.sourceStatus = null;
      this.ctypeStatus = null;
      this.chooseDateVal = null;
      this.pageNum = 1;
      this.getListData();
    },
    // 添加预约--跳转
    addBespeak() {
      window.sessionStorage.bespeakId = '';
      this.$router.push({
        name: 'stage-bespeakService'
      });
    },
    // 跳转到服务开单--所带参数
    bespeakBilling(id) {
      if (this.Lib.checkPower('beauty-2-yykd') == false) return;
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.bookOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling'
      });
    },
    // 修改预约信息
    bespeakEdit(id, source) {
      if (this.Lib.checkPower('beauty-2-xgyy') == false) return;
      window.sessionStorage.bespeakId = id;
      if (source == 1) {
        this.$router.push({
          name: 'stage-bespeakTechnician'
        });
      } else {
        this.$router.push({
          name: 'stage-bespeakService'
        });
      }
    },
    // 待确认状态修改  1是确认  0是拒绝
    isConfirm() {
      const data = {
        orderId: this.chooseId,
        type: this.diaStatus
      };
      getSureOrFalse(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: this.diaStatus == 1 ? '确认成功' : '拒绝成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.getListData();
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 结算
    settlementOrder(id) {
      if (this.Lib.checkPower('beauty-2-yyjs') == false) return;
      window.sessionStorage.settlementOrderId = id;
      this.$router.push({
        name: 'stage-orderSettlement'
      });
    },
    // 预约详情
    bespeakDetails(id) {
      if (this.Lib.checkPower('beauty-2-ckyy3') == false) return;
      this.detailsVisible = true;
      getBookOrderDetail({ orderId: id }).then((res) => {
        if (res.code == 0) {
          this.detailsInfo = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 取消预约
    cancelBespeak(id, val) {
      if (val === 2) {
        if (this.Lib.checkPower('beauty-2-qxyy') == false) return;
        getBookCancelMsg({ id }).then((res) => {
          if (res.code == 0) {
            this.chooseId = id;
            this.cancelStatus = res.data ? res.data.cancelStatus ? 1 : 0 : 0;
            this.diaStatus = val;
            this.dialogVisible = true;
          } else {
            console.log(res);
          }
        });
      } else if (val === 0) {
        if (this.Lib.checkPower('beauty-2-yyxxqr') == false) return;
        this.chooseId = id;
        this.diaStatus = val;
        this.cancelStatus = 1;
        this.dialogVisible = true;
      } else {
        if (this.Lib.checkPower('beauty-2-yyxxqr') == false) return;
        this.chooseId = id;
        this.diaStatus = val;
        this.cancelStatus = 1;
        this.isConfirm();
      }
    },
    // 确定取消预约
    comfirmCancelBespeak() {
      if (this.diaStatus === 2) {
        const data = {
          id: this.chooseId
        };
        getBookFailures(data).then((res) => {
          if (res.code == 0) {
            this.$message({ message: '取消成功', type: 'success' });
            this.dialogVisible = false;
            this.getListData();
          } else {
            console.log(res);
          }
        });
      } else {
        this.isConfirm();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 预约列表
    getListData() {
      const vm = this;
      vm.loading = true;
      const data = {
        startDate: '',
        endDate: '',
        keyWord: vm.inputVal ? vm.inputVal : null,
        pageNum: vm.pageNum,
        pageSize: vm.pageSize,
        type: vm.bespeakStatus ? vm.bespeakStatus : null,
        remark: vm.remark,
        source: vm.sourceStatus,
        technicianId: this.technicianVal ? this.technicianVal : null,
        clientType: vm.ctypeStatus,
      };
      if (this.chooseDateVal == 0) {
        this.value = [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];
      } else if (this.chooseDateVal == 1) {
        this.value = [dayjs().subtract(1, 'day').format('YYYY-MM-DD'), dayjs().subtract(1, 'day').format('YYYY-MM-DD')];
      } else if (this.chooseDateVal == 2) {
        this.value = [dayjs().add(1, 'day').format('YYYY-MM-DD'), dayjs().add(1, 'day').format('YYYY-MM-DD')];
      } else if (this.chooseDateVal == 3) {
        this.value = [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')];
      }
      if (vm.value) {
        data.startDate = vm.value[0];
        data.endDate = vm.value[1];
      }
      getBookOrderList(data).then((res) => {
        vm.tableData = res.data.records;
        vm.rowCount = res.data.total;
        vm.pageSize = res.data.size;
        vm.loading = false;
      });
    },
    // 打开设置排班
    setScheduling() {
      this.$router.push({
        name: 'stage-setScheduling'
      });
    },
    // 订单已读操作
    orderRead(id) {
      const data = { id };
      bookRead(data).then((res) => {
        if (res.code == 0) {
          $('#socketBespeakStatus').text(
            $('#socketBespeakStatus').text() * 1 - 1
          );
          this.getListData();
          this.getBookReadStatus();
        } else {
          // console.log(res.msg);
        }
      });
    },
    getBookReadStatus() {
      getBookReadStatus().then((res) => {
        if (res.data === 'false') {
          $('#socketBespeakStatus').css('display', 'none');
        }
      });
    },
    initialize(val) {
      if (window.sessionStorage.addRevation == '1' || val == 1) {
        const date = new Date();
        const today = this.Lib.D(date.getTime(), 'yyyy-MM-dd');
        const todaySeven = this.Lib.D(date.getTime() + 3600 * 1000 * 24 * 2, 'yyyy-MM-dd');
        this.value = [today, todaySeven];
        this.inputVal = '';
        this.remark = '';
        this.bespeakStatus = '';
        this.sourceStatus = null;
        this.ctypeStatus = null;
        this.chooseDateVal = null;
        this.pageNum = 1;
        this.getListData();
        window.sessionStorage.addRevation = '2';
      } else {
        this.getListData();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.screen {
  color: #999;
  font-size: 20px;
  cursor: pointer;
  float: right;
  position: relative;
  z-index: 1;
  margin-top: -61px;
}
.yyTop {
  background-color: #F5F7FA;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  i {
    font-weight: 100;
    position: relative;
    top: 2px;
    font-size: 20px;
    font-weight: bold;
  }
  span {
    font-size: 18px;
    font-weight: bold;
    padding-left: 5px;
  }
  samp {
    font-size: 14px;
    color: #FA5555;
    float: right;
  }
}
.yyInfoTitle {
  padding: 20px 20px 0 20px;
  .sl {
    float: left;
    width: 5px;
    height: 15px;
    background-color: #409EFF;
    border-radius: 4px;
    position: relative;
    top: 2px;
    margin-right: 5px;
  }
  .sm {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
.yyInfo {
  display: table;
  p {
    display: flex;
    padding-top: 20px;
    line-height: 16px;
    font-size: 14px;
    span {
      width: 90px;
      float: left;
      text-align: right;
      color: #666;
    }
    samp {
      flex: 1;
      padding-right: 20px;
      color: #000;
    }
  }
  h5 {
    width: 560px;
    padding-top: 20px;
    line-height: 16px;
    font-size: 14px;
    span {
      width: 90px;
      float: left;
      text-align: right;
      color: #666;
    }
    samp {
      color: #000;
    }
    label {
      cursor: pointer;
      float: right;
      color: #409EFF;
    }
    i {
      cursor: pointer;
      float: right;
      color: #409EFF;
      padding: 0 20px 0 5px;
      position: relative;
      top: 1px;
    }
  }
}
.yyFoot {
  padding: 20px;
  float: right;
}
</style>

<style>
.yyDetails .el-dialog .el-dialog__body {
  padding: 0;
}
</style>
